import { Link, useNavigate } from 'react-router-dom';
import { ConfirmCodeForm, SignUpComplete, SignUpFormFields } from '../components/SignUpForm';
import { useSignUp } from '../hooks/use-sign-up';

export function SignUpPage() {
  const navigate = useNavigate();

  const form = useSignUp({
    autoSignIn: true,
    onDone: () => navigate('/auth/signin'),
  });

  if (form.step === 'complete') {
    return (
      <SignUpComplete
        message="サインインしてご利用ください。"
        buttonLabel="サインインへ"
        onNavigate={() => navigate('/auth/signin')}
      />
    );
  }

  if (form.step === 'confirm') {
    return <ConfirmCodeForm {...form} onSubmit={form.handleConfirm} />;
  }

  return (
    <SignUpFormFields
      {...form}
      onSubmit={form.handleSignUp}
      title="サインアップ"
      subtitle="新しいアカウントを作成"
      submitLabel="サインアップ"
      submittingLabel="サインアップ中..."
      footer={
        <div className="mt-6">
          <Link
            to="/auth/signin"
            className="block text-center text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            すでにアカウントをお持ちの方は
            <span className="text-primary-400">サインイン</span>
          </Link>
        </div>
      }
    />
  );
}
